import styled from 'styled-components';

export const ClientSingleApplicationPageContainer = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

export const ClientSingleApplicationPageLoadError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.md}px;
  min-height: 100%;
  padding: ${({ theme }) => theme.spacing.xl}px;
  text-align: center;
`;
